import React from 'react'

export const BtnMenu = () => {
  return (
    <div className='d-flex justify-content-center'>
      <div className='btn btn-menu'>
        <a href="#" className='text-warning'>Cardapio Completo</a>
      </div>
    </div>
    
  )
}
